/** @module Enums */ /** typedoc */

export enum SocialNetworksEnum {
    Twitter = 'Twitter',
    Facebook = 'Facebook'
}
